/**
 * @name LoginPage
 * @description Página de login do sistema
 * @author Gabriel M. Guimarães | gabrielmg7
 */

import LoginComponent from '@/components/pages/Auth/Login/Login';

export const LoginPage = LoginComponent;
